import React from "react";
import {
  CategoryIconMap,
  DestinationCategory,
} from "../../models/DestinationCategory";
import {getCategoryLabel, useTranslation} from "../../i18n/LanguageProvider";

interface Props {
  categories: DestinationCategory[];
}

const DestinationGroupCategoryLabels: React.FC<Props> = ({ categories }) => {
  const {t} = useTranslation();

  return (
    <div className="flex flex-wrap gap-2.5">
      {categories.map((category, index) => (
        <div
          key={index}
          className="rounded-lg px-3.5 gap-0.5 py-1.5 bg-white text-primary font-semibold flex items-center text-[10px]"
        >
          {/* Icon */}
          <span className="mr-1 fill-primary">{CategoryIconMap[category]}</span>
          {/* Label */}
          <span>{getCategoryLabel(category, t)}</span>
        </div>
      ))}
    </div>
  );
};

export default DestinationGroupCategoryLabels;
